const GroupsService = (type, action) => {
	let parsed = null;

	switch (type) {
		case "SEARCH": {
			const payload = { q: action.query };
			parsed = { type: "GET", url: "/api/v0.1/groups/", payload };
			break;
		}

		case "GET": {
			parsed = {
				type: "GET",
				url: `/api/v0.1/groups/${action.groupID}/`,
			};
			break;
		}

		default: {
			break;
		}
	}

	return parsed;
};

export default GroupsService;
